import axios from 'axios';
import { Domain } from '../models/domain.model';
import { Plugins } from '@capacitor/core';
const { Storage } = Plugins;

export const getDomain = (domain: string) => {
    let domainUrl = `${process.env.REACT_APP_REFERENCE_API_URL}/Domain/${domain}`;
    return axios.get(domainUrl)
}

export const setDomainStorage = async (domain: Domain) => {
    return getDomainStorage().then(async (domainList: Domain[]) => {
        const existingDomain = domainList.find((f: Domain) => f.Code === domain.Code);
        if (!existingDomain) {
            domainList.push(domain);
        }
        return await Storage.set({
            key: 'domainList',
            value: JSON.stringify(domainList)
        });
    });

}

export const updateDomainStorage = async (newdomainList: Domain[]) => {
    return await Storage.set({
        key: 'domainList',
        value: JSON.stringify(newdomainList)
    });
}

export const getDomainStorage = async (): Promise<Domain[]> => {
    const ret = await Storage.get({ key: 'domainList' });
    let domainList: Domain[];
    domainList = ret && ret.value ? domainList = JSON.parse(ret.value!) : [];
    return domainList;
}

